import { useMemo } from 'react';
import { receiptAdapter } from '../libs/reciptAdapter';
import { useQuery } from '@tanstack/react-query';
import { orderAPI } from '../api/orderAPI';
export const useGetRecipt = (id: string) => {
  const initData = useMemo(() => ({ receipt: receiptAdapter() }), []);
  const { data = initData, isLoading } = useQuery({
    queryKey: ['receipt', id],
    queryFn: async () => await orderAPI.recipt(id),
    select: data => ({ receipt: receiptAdapter(data.data) }),
  });
  return {
    ...data,
    isLoading,
  };
};
